import { createAction, props } from '@ngrx/store';
import { ORDER_EXPERIENCES } from '@ordersnproducts/modules/shared/constants/order-experiences';
import { CxCustomerExperienceResponse } from '../../models/customer-experiences';

export const fetchCustomerExperiences = createAction(
  '[CUSTOMER] Fetch Entity Experiences start',
  props<{ customerId: number }>(),
);

export const fetchCustomerExperiencesFiltered = createAction(
  '[CUSTOMER] Fetch Entity Experiences Filtered start',
  props<{ customerId: number; productType: string; experience: ORDER_EXPERIENCES }>(),
);

export const fetchCustomerExperiencesFilteredComplete = createAction(
  '[CUSTOMER] Fetch Entity Experiences Filtered end',
  props<{ customers: CxCustomerExperienceResponse }>(),
);

export const fetchCustomerExperiencesFilteredFailed = createAction(
  '[CUSTOMER] Fetch Entity Experiences Filtered failed',
  props<any>(),
);

export const CxCustomerActions = {
  fetchCustomerExperiences,
  fetchCustomerExperiencesFiltered,
  fetchCustomerExperiencesFilteredComplete,
  fetchCustomerExperiencesFilteredFailed,
};

export default CxCustomerActions;
